/** @format */
import React from "react";

import { useMediaQuery } from "@mui/material";

import NavBarDesktop from "./NavBarDesktop";
import NavBarMobile from "./NavBarMobile";

const NavBar = () => {
	const isMobile = useMediaQuery("(max-width:1005px)");

	return !isMobile ? <NavBarDesktop /> : <NavBarMobile />;
};

export default NavBar;
